import CSS from 'csstype';
import React from 'react';

import {
  disableSelectTextStyle,
  FONT_WEIGHT,
  fontSize,
  fontWeight,
} from '~/src/dash/components/text/common';
import { fontSizing, usePanel } from '~/src/dash/publicaUI';

interface ITextButtonProps {
  size?: fontSize;
  allCaps?: boolean;
  weight?: fontWeight;
  color?: string;
  enableTextWrap?: boolean;
  onClick: (props?: any | null) => void;
  disabled?: boolean;
  style?: CSS.Properties;
  className?: string;
  children?: any;
}

export const TextButton = ({
  size,
  allCaps,
  weight,
  color,
  enableTextWrap,
  onClick,
  disabled,
  style,
  className = '',
  children,
}: ITextButtonProps) => {
  const { theme } = usePanel();

  return (
    <div
      onClick={disabled ? () => null : onClick}
      className={className}
      style={{
        display: 'inline-block',
        padding: 0,
        margin: 0,
        whiteSpace: enableTextWrap ? 'normal' : 'nowrap',
        fontSize: size ? fontSizing[size] : fontSizing.base,
        fontWeight: weight ? FONT_WEIGHT[weight] : FONT_WEIGHT.bold,
        textTransform: allCaps ? 'uppercase' : 'inherit',
        color: disabled ? theme.secondaryButtonDisabled : color || theme.secondaryButtonText,
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...disableSelectTextStyle,
        ...style,
      }}
    >
      {children}
    </div>
  );
};
